import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css/effect-fade';

export const Slider = ({ children, settings = {}, className }) => {
    const sliderOptions = {
        slidesPerView: 1,
        pagination: true,
        navigation: false,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        effect: 'fade',
        ...settings,
    };

    return (
        <Swiper {...sliderOptions} className={className} modules={[Autoplay, EffectFade]}>
            {children}
        </Swiper>
    );
};

export { SwiperSlide as Slide };
